import React, { Component } from "react";
import styles from "./routesList.module.scss";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import { states } from "../../../reducers/queriesStates";
import Preloader from "./../../../shared/items/static/preloader";
import Notification from "./../../../shared/items/static/notification";
import RoutesListItems from "./routesListItems";

class RoutesList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { routesDataState, onGetRoutes, requestOptions } = this.props;

    if (routesDataState === states.NOT_REQUESTED) {
      onGetRoutes(requestOptions);
    }
  }

  render() {
    const { routes, routesDataState, handleScrollTo } = this.props;

    return (
      <React.Fragment>
        <div className={styles.routesList_wrapper}>
          {routes.length > 0 ? (
            <div className={styles.routesList}>{<RoutesListItems data={routes} handleScrollTo={handleScrollTo} />}</div>
          ) : (
            <Notification type="warning">
              <p>По данным параметрам поиска маршруты не найдены.</p>
            </Notification>
          )}
          {routesDataState !== states.READY ? (
            <div className={styles.container_preloader}>
              <Preloader />
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default withRoutes(RoutesList);
